module.exports = require("./fr-ML.js");